import React from "react";

import { cn } from "../../../common/u1/cn";
import { EditSectionLayout } from "./EditSectionLayout";
import { EditFooterBar } from "./EditFooterBar";
import { DocumentSlot } from "./DocumentSlot";
import { useDocumentUploads } from "./useDocumentUploads";
import { DOCUMENT_SPECS } from "./documentSpecs";

/* Sections 17–19 — MOA, Trade License and VAT Certificate. */
export const UploadDocumentSection = ({
  onNext,
  onPrev,
  onSkip,
  header,
  isLast = false,
  className = "",
}) => {
  const { company, upload, busyField, errors } = useDocumentUploads();

  return (
    <EditSectionLayout
      className={className}
      header={header}
      footer={
        <EditFooterBar
          onBack={onPrev}
          onSkip={onSkip}
          onContinue={onNext}
          continueLabel={isLast ? "Finish and Submit" : "Save & Continue"}
        />
      }
    >
      <h2 className="m-0 text-[16px] font-bold text-[var(--ink)] font-sans">
        Upload Document
      </h2>

      <div
        className={cn(
          "mt-3.5 rounded-[14px] border border-[var(--line)] bg-white",
          "p-4 sm:p-6"
        )}
      >
        <div className="grid grid-cols-1 gap-x-6 gap-y-5 sm:grid-cols-2">
          {DOCUMENT_SPECS.map((spec) => (
            <DocumentSlot
              key={spec.field}
              spec={spec}
              url={company?.[spec.field]}
              uploading={busyField === spec.field}
              error={errors[spec.field]}
              onUpload={(file) => upload(spec, file)}
            />
          ))}
        </div>
      </div>
    </EditSectionLayout>
  );
};

export default UploadDocumentSection;
